import { useState } from 'react';
import axios from 'axios';
import { useModalOpen } from '../../../hooks/useToastModalOpen';
import { exitToLogin } from '../../../component/AxiosCORS';

import { NotiDalgu } from '../../../images/icons/icons_component'

const WithdrawalUser_modal = ({withdrawalUser, setWithdrawalUser, withdrawalUserOpen, setWithdrawalUserOpen, handleInputChange, setMypageModal, setReSearch}) => {

    const {toastModalOpen} = useModalOpen();

    // 마이페이지에서 열면(setMypageModal 이 있으면) 본인 탈퇴다. 본인 탈퇴는 현재 비밀번호를 확인한다.
    // 사용자관리에서 열면 관리자가 남을 탈퇴시키는 것이라 비밀번호 칸이 없다(서버가 관리 권한 · 범위를 확인한다).
    const selfMode = setMypageModal !== undefined;
    const [pswd, setPswd] = useState('');

    const withdrawalUserHandler = async (withdrawalUser) => {
        try {
            if(window.confirm('탈퇴 처리하시겠습니까?')) {
                if(withdrawalUser.deletereason === '01' || withdrawalUser.deletereason === '02') {
                    withdrawalUser.deletemsg = ''
                };
                // 처리자는 서버가 로그인한 사람으로 기록한다
                const response = await axios.post('/commonapi/withdrawalUser.do', {
                    useridno: withdrawalUser.useridno,
                    deletereason: withdrawalUser.deletereason,
                    deletemsg: withdrawalUser.deletemsg,
                    ...(selfMode ? { userpswd: pswd } : {}),
                });

                const resultMap = response.data?.resultMap;
                if (resultMap && resultMap.result === false) {
                    setPswd('');
                    // 비밀번호를 5회 틀려 계정이 잠겼다. 서버가 이미 로그아웃시켰다
                    if (resultMap.locked) {
                        setWithdrawalUserOpen(false);
                        setMypageModal(false);
                        exitToLogin(resultMap.resultMessage);
                    } else {
                        alert(resultMap.resultMessage);
                    }
                    return;
                }

                if(selfMode) {
                    // 서버가 탈퇴와 함께 로그아웃시켰다. 화면도 정리하고 로그인 화면으로 보낸다
                    setPswd('');
                    setWithdrawalUserOpen(false);
                    setMypageModal(false);
                    exitToLogin('정상적으로 탈퇴 처리되었습니다.');
                } else {
                    toastModalOpen('정상적으로 탈퇴 처리되었습니다.');
                    setWithdrawalUserOpen(false);
                    setWithdrawalUser(prev => ({
                        ...prev,
                        deletereason: '01',
                        deletemsg: ''
                    }));
                    setReSearch(true);
                }
            }  
        } catch (error) {
            console.error('회원탈퇴 중 오류 발생:', error);
        }
    };

    const closeModal = () => {
        setWithdrawalUserOpen(false)
        setPswd('');
        setWithdrawalUser(prev => ({
            ...prev,
            deletereason: '01',
            deletemsg: ''
        }));
    }

    const reasonFilled = withdrawalUser.deletereason === '01' || withdrawalUser.deletereason === '02' || (withdrawalUser.deletereason === '03' && withdrawalUser.deletemsg?.length > 1);
    const deletereasonCheck = reasonFilled && (!selfMode || pswd.length > 0);

    return (
        <div className={`mypage_modal_container ${withdrawalUserOpen ? 'visible' : 'invisible'}`}>
            <div className='modal_title_box'>
                <NotiDalgu/>
                <h4 className='co_red'>탈퇴<span className='co_black'> 하시겠습니까?</span></h4>
            </div>
            <div className='text-center'>
                <p className='co_dark'>{`${withdrawalUser.username}(${withdrawalUser.useridno}) 님의 탈퇴 사유를 작성해 주세요.`}</p>
                <p className='bold co_dark'>회원 탈퇴 시 모든 개인정보는 해당 시스템에서</p>
                <p className='bold co_red'>삭제 처리되어 복구할 수 없습니다.</p>
            </div>
            <hr/>
            <div className='deletereason_box'>
                <div className='deletereason_checkbox'>
                    <label>
                        <input type='radio' name='deletereason' value='01'
                            checked={withdrawalUser.deletereason === '01'}
                            onChange={handleInputChange}
                        />
                        퇴사
                    </label>
                    <label>
                        <input type='radio' name='deletereason' value='02'
                            checked={withdrawalUser.deletereason === '02'}
                            onChange={handleInputChange}
                        />
                        부서이동
                    </label>
                    <label>
                        <input type='radio' name='deletereason' value='03'
                            checked={withdrawalUser.deletereason === '03'}
                            onChange={handleInputChange}
                        />
                        기타
                    </label>
                </div>
                <textarea name='deletemsg'
                        className={`textarea_style ${selfMode ? 'h-16' : 'h-24'}`}
                        value={withdrawalUser.deletereason === '01' || withdrawalUser.deletereason === '02' ? '' : withdrawalUser.deletemsg}
                        placeholder='기타를 선택 시 구체적인 사유를 작성해 주세요.'
                        disabled={withdrawalUser.deletereason === '03' ? false : true}
                        onChange={handleInputChange}/>
            </div>
            {/* 창 높이가 고정이라 비밀번호 칸은 라벨과 한 줄로 두고, 그만큼 사유 입력칸을 줄인다(본인 탈퇴일 때만) */}
            {selfMode &&
                <div className='flex items-center gap-3'>
                    <label className='ml-1 cursor-default' style={{ whiteSpace: 'nowrap' }} htmlFor='withdrawalPswd'>현재 비밀번호</label>
                    <div className={`pw_input ${pswd.length > 0 ? 'pw_input_ok' : ''}`}>
                        <input id='withdrawalPswd' className='outline_none' type='password' maxLength={20}
                            autoComplete='current-password' value={pswd} onChange={(e) => setPswd(e.target.value)} />
                    </div>
                </div>
            }
            <hr/>
            <div className='modal_btn_box'>
                <button className={`modal_btn ${deletereasonCheck ? 'bg_co_red' : 'bg_co_light'}`} disabled={!deletereasonCheck} onClick={() => withdrawalUserHandler(withdrawalUser)}>탈퇴하기</button>
                <button className='modal_btn bg_co_black' onClick={closeModal}>닫기</button>
            </div>
        </div>
    )
}

export default WithdrawalUser_modal